import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue"
import VueApexCharts from "vue-apexcharts"

import DashboardCard from "@/components/Common/DashboardCard"
import { useDownload } from "@/composables/useDownload"
import { TaskState, useTask } from "@/composables/useTask"
import i18n from "@/i18n"
import syncService from "@/services/syncService"
import { TaskStatus } from "@/types/common.type"

// Helper Types/Variables
type Props = {
  syncUuid: string
  fetching: boolean
  offersAllCount: number
  offersIsSellingCount: number
  offersNotSellingCount: number
  offersWithErrorsCount: number
  offersIsNeedActionCount: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SyncDashboardCard',
  props: {
    syncUuid: null,
    fetching: { type: Boolean },
    offersAllCount: null,
    offersIsSellingCount: null,
    offersNotSellingCount: null,
    offersWithErrorsCount: null,
    offersIsNeedActionCount: null
  },
  setup(__props: any) {

const props = __props as {
  syncUuid: string
  fetching: boolean
  offersAllCount: number
  offersIsSellingCount: number
  offersNotSellingCount: number
  offersWithErrorsCount: number
  offersIsNeedActionCount: number
};


// End Helper Types/Variables

const xmlWithErrors = ref<TaskState>({
  taskId: null,
  progress: 0,
  status: null,
  downloadUrl: null
})

// Composables
const { pollUrlTask } = useTask()
const { downloadFile } = useDownload()
// End Composables

// Computed
const series = computed(() => {
  return [
    props.offersIsSellingCount,
    props.offersNotSellingCount,
    props.offersWithErrorsCount,
    props.offersIsNeedActionCount
  ]
})
const chartOptions = computed(() => {
  return {
    labels: [
      i18n.t("synchronization.sells"),
      i18n.t("synchronization.not_sells"),
      i18n.t("synchronization.xml_errors"),
      i18n.t("synchronization.need_action")
    ],
    colors: ["#52C41A", "#FA8C16", "#F5222D", "#1890FF"],
    plotOptions: {
      pie: {
        expandOnClick: false,
        donut: {
          size: "50%"
        }
      }
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      show: false
    },
    tooltip: {
      fillSeriesColor: false,
      style: {
        fontSize: "13px",
        fontFamily: "Roboto"
      }
    },
    legend: {
      show: false
    }
  }
})
// End Computed

// Methods
const handleDownloadXmlWithErrors = async (format: "csv" | "xlsx") => {
  const response = await syncService.getXmlWithErrors(props.syncUuid, format)

  xmlWithErrors.value.taskId = response?.task_id

  const url = await pollUrlTask(xmlWithErrors.value.taskId, xmlWithErrors, (taskUuid) =>
    syncService.getReportState({
      synchronizationUuid: props.syncUuid,
      taskUuid
    })
  )

  if (url) {
    downloadFile(url)
  }
}
// End Methods

return { __sfc: true,props, xmlWithErrors, pollUrlTask, downloadFile, series, chartOptions, handleDownloadXmlWithErrors, VueApexCharts, DashboardCard, TaskStatus }
}

})